import {
  Flex,
  Icon,
  Image as CImage,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { default as ITicketIcon } from "@icons/TicketMonoIcon";
import { NFTReward, NFTRewardType } from "@models/event/reward";
import CheckoutSuccessButtons from "../CheckoutSuccessButtons/CheckoutSuccessButtons";
import CheckoutSuccessContainer from "../CheckoutSuccessContainer/CheckoutSuccessContainer";
import {
  ContactUsCard,
  ShareEventCard,
} from "../CheckoutSuccessCTA/CheckoutSuccessCTACards";
import { CheckoutSuccessContentProps } from "../types";

const HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";

const RewardComponent = ({ reward }: { reward: NFTReward }) => (
  <>
    {reward.type == NFTRewardType.TEXT && (
      <div className="bg-primary-50 self-stretch text-[#23262F] text-center p-4 rounded-lg whitespace-pre-line">
        {reward.content}
      </div>
    )}

    {reward.type == NFTRewardType.URL && (
      <div className="bg-primary-50 self-stretch text-[#23262F] text-center p-4 rounded-lg whitespace-pre-line">
        {_t("Go to this page and sign up for your redeemable.")}
        <br />
        <span className="text-primary-500 text-xl">{reward.content} </span>
      </div>
    )}
  </>
);

const _t = (key?: string) => key || "";
const CheckoutSuccessBenefit = ({
  event,
  tier,
  info,
  language,
  reward,
}: CheckoutSuccessContentProps) => (
  <CheckoutSuccessContainer>
    <CImage
      maxW={{ base: "100%", lg: 160 }}
      background="#000000"
      objectFit="contain"
      src={tier?.imageUrl || info.hero || info.banner}
      alt={info.name}
      borderRadius="md"
    />
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={6}
      width="100%"
    >
      <Text className="text-2xl dark:text-white text-center">
        <Icon as={ITicketIcon} color={"primary.300"} boxSize={6} mr={4} />
        {_t("Congrats! Your ")}
        <span className="text-primary-500 font-medium">
          {tier?.name || "Redeemable"}
        </span>
        {_t(" was successfully redeemed.")}
      </Text>
      <Text
        className="text-base"
        align="center"
        color={useColorModeValue("neutral.600", "white")}
      >
        {_t(
          "You can check your redeemable on the benefits page of your user app."
        )}
      </Text>

      {reward && <RewardComponent reward={reward} />}

      <Flex
        width="100%"
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={6}
        flexWrap="wrap"
      >
        <ShareEventCard
          language={language}
          eventType={event.type}
          url={event.toURL(HOST)}
        />
        <ContactUsCard language={language} />
      </Flex>

      <CheckoutSuccessButtons
        redirectToAppText="Back to Benefits"
        redirectToEventText="Back to Redeemable"
      />
    </Flex>
  </CheckoutSuccessContainer>
);

export default CheckoutSuccessBenefit;
